import React from "react";

const InputErrorMessage: React.FC<{ errorMessage: string }> = ({
  errorMessage,
}) => {
  return (
    <>
      {errorMessage && (
        <small className="text-danger bg-white bg-opacity-100 small_text mt-1">
          {errorMessage}
        </small>
      )}
    </>
  );
};

export default InputErrorMessage;
